import { render, staticRenderFns } from "./infoMenu.vue?vue&type=template&id=87ca47b6&scoped=true&"
import script from "./infoMenu.vue?vue&type=script&lang=js&"
export * from "./infoMenu.vue?vue&type=script&lang=js&"
import style0 from "./infoMenu.vue?vue&type=style&index=0&id=87ca47b6&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ca47b6",
  null
  
)

export default component.exports